// extracted by mini-css-extract-plugin
module.exports = {"relatedContainer":"Related_relatedContainer__bGIPF","containerTitle":"Related_containerTitle__uqtoT","slideItem":"Related_slideItem__bbhy3","title":"Related_title__zFyjf"};